import { AdditionalCodeReferenceBlockData } from "models/interfaces/additional-block-data/additional-code-reference-block-data";
import { ReadonlyPageBlockProps } from "organisms/page-blocks/readonly-page-block/readonly-page-block";
import { ReadonlyPageBlockContent } from "organisms/page-blocks/readonly-page-block/readonly-page-block-content";
import React from "react";
import CodeReferenceBlockEnhancedContentContextProvider from "utilities/contexts/notebooks/use-code-reference-block-enhanced-content-context";
import { useCodeReferenceBlockSection } from "utilities/hooks/domain/block-configurations/use-code-reference-block-section";

interface ReadonlyCodeReferencePageBlockProps extends ReadonlyPageBlockProps {
    recipientGuid?: string;
    sharedPageGuid?: string;
}

export const ReadonlyCodeReferencePageBlock: React.FC<
    ReadonlyCodeReferencePageBlockProps
> = (props: ReadonlyCodeReferencePageBlockProps): JSX.Element => {
    const { section } = useCodeReferenceBlockSection(props.block);
    const additionalBlockData: AdditionalCodeReferenceBlockData = {
        section: section,
        highlights: [],
    };

    return (
        <CodeReferenceBlockEnhancedContentContextProvider>
            <ReadonlyPageBlockContent
                {...props}
                additionalBlockData={additionalBlockData}
            />
        </CodeReferenceBlockEnhancedContentContextProvider>
    );
};
